import { ReactNode } from "react";
import { createPortal } from "react-dom";

/** Render modal overlays on document.body so they sit above the app header. */
export function ModalPortal({ children }: { children: ReactNode }) {
    if (typeof document === "undefined") return null;
    return createPortal(children, document.body);
}
